const paypoint = {
    id: `paypoint-${Math.random()}`,
    title: 'Paypoint',
    type: 'item',
    url: `/report/paypoint`,
    // icon: icons.IconReport,
    breadcrumbs: false,
    // children: transChild,
    role: process.env.REACT_APP_RL_PAYPOINTCOL
};

export default paypoint;